/*
**************************** 
홈페이지 우편번호 주소록
*****************************
*/

import React from 'react';
import DaumPostcode from "react-daum-postcode";
import "../css/PopupDom.css";

function PopupDom(props) {
    const { open, close, header } = props;

    const handlePostCode = (data) => {
        let fullAddress = data.address;
        let extraAddress = '';

        if (data.addressType === 'R') {
            if (data.bname !== '') {
                extraAddress += data.bname;
            }
            if (data.buildingName !== '') {
                extraAddress += (extraAddress !== '' ? `, ${data.buildingName}` : data.buildingName);
            }
            fullAddress += (extraAddress !== '' ? ` (${extraAddress})` : '');
        }

        props.dataCall(fullAddress);
        props.onClose();
    }

    const postCodeStyle = {
        height: "460px",
    };

    return (
        <div className={open ? 'openModal modal' : 'modal'}>
            {open ? (
                <section>
                    <header>
                        {header}
                        <button className="close" onClick={close}>
                            &times;
                        </button>
                    </header>
                    <main>    <DaumPostcode style={postCodeStyle} onComplete={handlePostCode} /></main>
                </section>
            ) : null}
        </div>
    );
};


export default PopupDom;